import { useContext } from 'react';
import { EWIPDashboardScreenContext } from '../DashboardProvider';
import { Button, ButtonGroup, Card, CircularProgress, Grid, Hidden } from '@material-ui/core';
import { WipNoRecord, WipScreenLoader } from './wipDash-Loader';

export const WipDashboardHours = ({ classes, onChartClickHandler }) => {
    const { state, array, HoursData, handleBar, handleChangeByTime, getHoursObj } = useContext(EWIPDashboardScreenContext);

    return state.showHeaderLoader ? (
        <div className="wip-dash-Card">
            <WipScreenLoader />
        </div>
    ) : (
        <Card className="wip-dash-Card">
            <Hidden only={['xs']}>
                <Grid container justifyContent="space-between">
                    <Grid item xs={12} sm={6} style={{ float: 'right' }}>
                        <div
                            style={{
                                width: '100%',
                                textAlign: 'left',
                                color: '#f50057',
                                fontWeight: 600,
                                margin: '10px 20px'
                            }}
                        >
                            <ButtonGroup color="secondary" ria-label="outlined primary button group" size="small">
                                {HoursData.map((n, i) => {
                                    return (
                                        <Button
                                            key={i}
                                            variant={array.hourType === n.id ? 'contained' : 'outlined'}
                                            onClick={() => handleBar(n.id)}
                                            style={{ fontSize: 10 }}
                                        >
                                            {n.name}
                                        </Button>
                                    );
                                })}
                            </ButtonGroup>
                        </div>
                        {/* <Typography vraient="h5" color="secondary" className="dashHeading">
                                        Clocked Hours
                                    </Typography> */}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <div style={{ float: 'right', marginRight: 40 }}>
                            <select onChange={handleChangeByTime} className="selectclass" value={array.byTimeBranch}>
                                <option value={'Default'}>All Branches</option>
                                {state.chartdata.map((btn, i) => {
                                    return (
                                        <option key={i} value={btn.name}>
                                            {btn.name}{' '}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                    </Grid>
                </Grid>
            </Hidden>
            <Hidden only={['sm', 'md', 'lg', 'xl']}>
                <Grid container justifyContent="space-between" spacing={0}>
                    <Grid item xs={12} sm={6}>
                        <div
                            style={{
                                margin: '0px 20px',
                                textAlign: 'left'
                            }}
                        >
                            <span className="lableFont">Hours</span>
                            <select
                                color="secondary"
                                onChange={handleBar}
                                aria-label="outlined primary button group"
                                size="small"
                                className="ButtonDropDown"
                                value={array.hourType}
                            >
                                {HoursData.map((n, i) => {
                                    return (
                                        <option key={i} value={n.id}>
                                            {n.name}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <div style={{ margin: '0px 20px', textAlign: 'left' }}>
                            <span className="lableFont">Branch</span>
                            <select onChange={handleChangeByTime} className="selectclass" value={array.byTimeBranch}>
                                <option value={'Default'}>All Branches</option>
                                {state.chartdata.map((btn, i) => {
                                    return (
                                        <option key={i} value={btn.name}>
                                            {btn.name}{' '}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                    </Grid>
                </Grid>
            </Hidden>

            <div style={{ padding: '0px 30px' }}>
                <hr className="labeled-bordered-box" />
            </div>
            <Grid container spacing={0} style={{ padding: '0px 20px' }} justifyContent="flex-start">
                {state.showClokedHours ? (
                    <div className="wip-dash-Card">
                        <WipScreenLoader />
                    </div>
                ) : getHoursObj.length > 0 ? (
                    getHoursObj.map((g, i) => {
                        if ((state.selectedBranch == 'Default' && g.bn == 'Default') || g.bn == state.selectedBranch) {
                            const { bn, branchID, hoursTaken = 0, orderIndex, workflow, workflowID, hoursAllowed = 0, hoursRemaining = 0 } = g;
                            return (
                                <div key={i + 1}>
                                    <Grid
                                        item
                                        style={{ padding: '5px 0px' }}
                                        onClick={() =>
                                            onChartClickHandler(
                                                { workflowID: workflowID, workflow: workflow, ...(state.selectedBranch != 'Default' && { bn: bn }) },
                                                true
                                            )
                                        }
                                    >
                                        <div style={{ borderLeft: '5px solid #88EBA4' }} className="wip-dash-Card-content">
                                            <div className="wip-dash-Card-content-values">
                                                <span className="lableFont">{workflow}</span>
                                                <div className="valueFont">
                                                    {array.hourType === 'clocked'
                                                        ? hoursTaken?.toFixed(2)
                                                        : array.hourType === 'allowed'
                                                        ? hoursAllowed?.toFixed(2)
                                                        : hoursRemaining.toFixed(2)}
                                                </div>
                                            </div>
                                        </div>
                                    </Grid>
                                </div>
                            );
                        }
                    })
                ) : (
                    <WipNoRecord />
                )}
            </Grid>
        </Card>
    );
};
